/**
 * 图片的处理
 *
 */
// 图片总数
const totalImages = 1450;

// 存储分配的图片编号
const usedImages = new Set<number>();

// 简单的哈希函数，将字符转换为数值
export const generateHashFromText = (text: string): number => {
  let hash = 2166136261; // FNV-1a 初始化偏置
  for (let i = 0; i < text.length; i++) {
    // 从索引 0 开始
    hash ^= text.charCodeAt(i);
    hash = (hash * 16777619) >>> 0; // 保持 32 位无符号整数
  }
  return hash >>> 0; // 返回无符号 32 位整数
};

// 分配图片，确保唯一性和确定性
export const assignImages = (text: string[], totalImages): Record<string, number> => {
  const textToImage: Record<string, number> = {};

  text.forEach(item => {
    // 生成基于哈希的图片索引
    let imageIndex = generateHashFromText(item) % totalImages;

    // 使用线性探测法，确保唯一性
    while (usedImages.has(imageIndex)) {
      imageIndex = (imageIndex + 1) % totalImages;
    }

    textToImage[item] = imageIndex;
    usedImages.add(imageIndex);
  });

  return textToImage;
};
export const resolveImgPath = (src: string) => {
  return new URL(`../assets/${src}`, import.meta.url).href;
};

/** 获取游戏的图片 */
export const getGamesUrl = (pack: string | number) => {
  const gameJsonOrigin = import.meta.env.VITE_GAME_JSON_ORIGIN;
  const url = `/game_data/img/${pack}.webp`;
  if (!gameJsonOrigin || gameJsonOrigin === '/') {
    return `${window.imgPrefix}${url}`;
  }

  // 本地
  return `${gameJsonOrigin}${url}`;
};

/** 获取头像 */
export function getAvatar(userId: number): string;
export function getAvatar(fileName: string): string;
export function getAvatar(value: number | string): string {
  if (!value) return '';

  if (value.toString().includes('_')) {
    // 图片
    return `${import.meta.env.VITE_IMAGE_PREFIX}/v1/images/${(value + '').replace('.webp', '')}`;
  }

  const lastId = value?.toString()?.slice(-1) ?? 0;
  return `${window.imgPrefix}/img/avatar/default_img_man_${lastId}.webp`;
}
